export default "__VITE_ASSET__43f2fb02__"